import baseV3Service from './base/baseV3Service.js';

const policyRequests = (payload, config) => {
    return baseV3Service.post("policies/request-access", payload, config);
};
const policyGrantAccess = (payload, config) => {
    return baseV3Service.post("policies/grant-access", payload, config);
};
const getPolicies = (config) => {
    return baseV3Service.get("policies", config);
};
const createUserAccessPolicy = (payload, config) => {
    return baseV3Service.post("policies/user-access", payload, config);
};
const deletePolicy = (id, config) => {
    return baseV3Service.delete(`policies/${id}`, config);
};

export { createUserAccessPolicy, deletePolicy, getPolicies, policyGrantAccess, policyRequests };
